import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAdminTabs } from "../api/tabsApi";
import { toast } from "react-toastify";

const AdminRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectToFirstTab = async () => {
      try {
        // Fetch the tabs allowed for this admin
        const tabsData = await fetchAdminTabs();

        if (tabsData.tabs && tabsData.tabs.length > 0) {
          // Get the first tab's path
          const firstTabPath = tabsData.tabs[0].path;
          console.log("🔄 Redirecting to first accessible tab:", firstTabPath);
          
          // Redirect to the first tab
          navigate(firstTabPath, { replace: true });
        } else {
          // If no tabs are available, redirect to homepage as fallback
          toast.warn("No tabs available, redirecting to homepage");
          navigate("/", { replace: true });
        }
      } catch (error) {
        console.error("❌ Error fetching tabs:", error);
        // Fallback to homepage if API fails
        navigate("/", { replace: true });
      }
    };

    redirectToFirstTab();
  }, [navigate]);

  // Show a loading state while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading your dashboard...</p>
      </div>
    </div>
  );
};

export default AdminRedirect;
